const DeviceClass = Object.freeze({
  Router: 'router',
  Switch: 'switch',
  Firewall: 'firewall',
  LoadBalancer: 'load_balancer',
  SdwanGateway: 'sd_wan_gateway',
  WirelessController: 'wireless_controller',
  AccessPoint: 'wireless_access_point',
  Server: 'server',
  UPS: 'ups',
  PDU: 'pdu',
  OpticalTransport: 'optical_transport',
  NetworkInterfaceDevice: 'network_interface_device',
  StorageArray: 'storage_array',
  SecurityAppliance: 'security_appliance'
});

const DEFAULT_DEVICE_CLASS = DeviceClass.Router;

// Classes for devices without NMS (SNMP/agent) telemetry, distinct from DeviceClass above.
const NonNmsDeviceClass = Object.freeze({
  Flow: 'flow',
  FlowIcmp: 'flow-icmp',
  Icmp: 'icmp'
});

const AllDeviceClass = Object.freeze({
  ...NonNmsDeviceClass,
  ...DeviceClass
});

module.exports = {
  DeviceClass,
  DEFAULT_DEVICE_CLASS,
  NonNmsDeviceClass,
  AllDeviceClass
};
